module.exports = __webpack_public_path__ + "img/logo.9c2c365a.svg";